import apiClient from "../apiClient";
import { API_ROUTES } from "../../config/baseURL";

export const getPlanPartoHistorico = async (unicId) => {
  const res = await apiClient.get(API_ROUTES.planPartoHistorico(unicId));
  return res.data;
};

export const getPlanPartoDetalle = async (idPlanParto) => {
  const res = await apiClient.get(API_ROUTES.planPartoDetalle(idPlanParto));
  return res.data;
};

export const createPlanParto = async (payload) => {
  const res = await apiClient.post(API_ROUTES.planParto, payload);
  return res.data;
};

export const updatePlanParto = async (payload) => {
  const res = await apiClient.put(API_ROUTES.planParto, payload);
  return res.data;
};

